import CommonMemberTable from "./commonModule/CommonMemberTable";

const MemberInProgress = () => {
  return <CommonMemberTable status="InProgress" title="Member Inprogress " />;
};

export default MemberInProgress;
